import * as React from "react";
import { Form, Col, Row, Table, Input,   Modal } from "antd";
import { Link } from "react-router-dom";
import Layouts from "../components/Layouts";
import HomeInsurancePolicy from "../components/grid/HomeInsurancePolicy";
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';


class HomeInsuranceList extends React.Component {

  constructor() {
    super();
    this.state = {
      searchBox: null,
      gotData: false,
      visible: false,
      visibleSearch: false,
      filterTable: null,
      baseData: [],
      riskItemId: '',
      columns: [{
        key: '1',
        title: 'Risk Item',
        dataIndex: 'riskitemname',
      },
      {
        key: '2',
        title: 'Rate (%)',
        dataIndex: 'ratepercentage',
      },
      {
        key: '3',
        title: 'Created Date',
        dataIndex: 'createddate',
      },
      {
        title: 'Actions',
        render: (record) => (
          <>
            <button onClick={() => this.EditRecord(record.riskcoverid)}><EditOutlined /></button>
            <button onClick={() => this.deleteRecord(record.riskcoverid)}><DeleteOutlined /></button>
          </>
        )
      }]
    }
    this.updateInput = this.updateInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setVisible = this.setVisible.bind(this);
    this.setVisibleFalse = this.setVisibleFalse.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.setVisibleSearch = this.setVisibleSearch.bind(this);
    this.EditRecord = this.EditRecord.bind(this);
  };
  search = value => {
    const { baseData } = this.state;

    const filterTable = baseData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k])
          .toLowerCase()
          .includes(value.toLowerCase())
      )
    );

    this.setState({ filterTable });
  };
  componentDidMount() {
    //Api call
    this.setState();
    fetch(process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetRiskItembyId/risk-item/0,' + localStorage.getItem('productId'))
      .then(res => res.json())
      .then(data => {
        this.setState({
          baseData: data,
        })
      })
  }

  deleteRecord(val) {
    alert(val);
  }

  onhandleChange() {
    alert('sadsad');
  }


  EditRecord(val) {
    this.setState({ riskItemId: val })
    this.setState({ visible: true });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {

      if (!err) {
        alert('asdsadsadsa');
      }
    });
  };

  // Functions for search functionality (if data not found)
  // Hide function to hide the modal after user clicked on cancel button
  hideModal() {
    this.setState({
      visibleSearch: false,
    });
  };

  // Redirecting to another model where client can add customer to the database
  setVisibleSearch() {
    this.setState({
      visibleSearch: false,
    });
    this.setState({ visible: true });
  }

  // Functions for Modal functioanlity to add customers
  setVisible() {
    alert('sadsasa');



  }
  setVisibleFalse() {
    this.setState({ visible: false });
  }

  // Functions for search functionality 
  handleChange({ target }) {
    this.setState({
      [target.name]: target.value
    });
  }




  updateInput() {
    if (this.state.searchBox === "Mayank") {
      alert("Data Found")
    }
    else {
      this.setState({
        visibleSearch: true,
      });
    }
  }


  render() {
    const { filterTable, baseData } = this.state;
    return (
      <Layouts title="assets" classname="dashboard">
        <div>
          <h3
            style={{
              color: "#0C1362",
              fontWeight: "600",
              fontSize: "24px",
            }}
          >
            Home/Domestic Insurance Quotation
          </h3>
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={20}>
              <Form.Item>
                <Input.Search

                  placeholder="Search ..."
                  enterButton
                  onSearch={this.search}
                />
              </Form.Item>
            </Col>

            <Col xs={12} sm={24} md={24} lg={4}>

              <Link to="/layout/addPolicy" className="btn btn-primary">Create Policy</Link>

            </Col>

            <Col xs={12} sm={24} md={24} lg={4}>
              <Modal title="Add Customer" centered visible={this.state.visible} footer={null} onCancel={this.setVisibleFalse} width={1000}>
                <HomeInsurancePolicy parentToChild={this.state.riskItemId} />
              </Modal>
            </Col>
          </Row>
          <Table columns={this.state.columns} dataSource={filterTable == null ? baseData : filterTable} scroll={{ x: 768 }} />

        </div>
      </Layouts>
    );
  }
}



export default HomeInsuranceList;
